"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactTable = require("react-table");

var _useUserData5 = _interopRequireDefault(require("../../hooks/useUserData"));

var _useUKFlexLayout = _interopRequireDefault(require("./useUKFlexLayout"));

var _DataTable = require("./DataTable.tools");

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Create a default prop getter
var defaultPropGetter = function defaultPropGetter() {
  return {};
};

var DataTable = function DataTable(_ref) {
  var dataTableId = _ref.id,
      initialColumns = _ref.columns,
      initialData = _ref.data,
      context = _ref.context,
      _ref$initialState = _ref.initialState,
      initialState = _ref$initialState === void 0 ? {} : _ref$initialState,
      dataTableTools = _ref.dataTableTools,
      stripped = _ref.stripped,
      hoverable = _ref.hoverable,
      bordered = _ref.bordered,
      selectable = _ref.selectable,
      subComponent = _ref.subComponent,
      backEndManagment = _ref.backEndManagment,
      className = _ref.className,
      children = _ref.children,
      _ref$getHeaderProps = _ref.getHeaderProps,
      getHeaderProps = _ref$getHeaderProps === void 0 ? defaultPropGetter : _ref$getHeaderProps,
      _ref$getColumnProps = _ref.getColumnProps,
      getColumnProps = _ref$getColumnProps === void 0 ? defaultPropGetter : _ref$getColumnProps,
      _ref$getRowProps = _ref.getRowProps,
      getRowProps = _ref$getRowProps === void 0 ? defaultPropGetter : _ref$getRowProps,
      _ref$getCellProps = _ref.getCellProps,
      getCellProps = _ref$getCellProps === void 0 ? defaultPropGetter : _ref$getCellProps;

  var dataTableRef = _react.default.useRef(null);

  var _React$useState = _react.default.useState(false),
      isDown = _React$useState[0],
      setIsDown = _React$useState[1];

  var _React$useState2 = _react.default.useState(0),
      startX = _React$useState2[0],
      setStartX = _React$useState2[1];

  var _React$useState3 = _react.default.useState(0),
      scrollLeft = _React$useState3[0],
      setScrollLeft = _React$useState3[1];

  var _React$useContext = _react.default.useContext(context || /*#__PURE__*/_react.default.createContext({})),
      crudState = _React$useContext.state,
      crudDispatch = _React$useContext.dispatch;

  var columns = _react.default.useMemo(function () {
    return initialColumns;
  }, [initialColumns]);

  var data = _react.default.useMemo(function () {
    return initialData;
  }, [initialData]); // const internalState = React.useMemo(() => initialState, [initialState]);
  // const [internalState, setInternalState] = React.useState(initialState);
  // React.useEffect(() => setInternalState(initialState), [initialState]);


  var renderRowSubComponent = _react.default.useCallback(function (_ref2) {
    var row = _ref2.row;
    return subComponent(row);
  }, [subComponent]);

  var fetchData = backEndManagment.fetchData,
      setBackEndFilter = backEndManagment.setBackEndFilter,
      controlledPageCount = backEndManagment.pageCount,
      controlledEntriesCount = backEndManagment.entriesCount,
      loading = backEndManagment.loading;

  var _React$useState4 = _react.default.useState(0),
      pIndex = _React$useState4[0],
      setPIndex = _React$useState4[1];

  var _React$useState5 = _react.default.useState(''),
      searchTerm = _React$useState5[0],
      setSearchTerm = _React$useState5[1]; //useUserData(dataTableId, 'searchTerm', initialState.searchTerm || '');


  var _useUserData = (0, _useUserData5.default)(dataTableId, 'sorting', initialState.sortBy || []),
      sorting = _useUserData[0],
      setSorting = _useUserData[1];

  var _useUserData2 = (0, _useUserData5.default)(dataTableId, 'pageSize', initialState.pageSize || 10),
      pSize = _useUserData2[0],
      setPSize = _useUserData2[1];

  var _useUserData3 = (0, _useUserData5.default)(dataTableId, 'colOrder', initialState.columnOrder || []),
      colOrder = _useUserData3[0],
      setColOrder = _useUserData3[1];

  var _useUserData4 = (0, _useUserData5.default)(dataTableId, 'hiddenCols', initialState.hiddenColumns || []),
      hiddenCols = _useUserData4[0],
      setHiddenCols = _useUserData4[1];

  var tools = _react.default.useMemo(function () {
    return {
      selectable: selectable,
      filterInput: _extends({}, DataTable.defaultProps.dataTableTools.filterInput, dataTableTools.filterInput),
      filterToggle: _extends({}, DataTable.defaultProps.dataTableTools.filterToggle, dataTableTools.filterToggle),
      pages: _extends({}, DataTable.defaultProps.dataTableTools.pages, dataTableTools.pages),
      pagination: _extends({}, DataTable.defaultProps.dataTableTools.pagination, dataTableTools.pagination),
      pager: _extends({}, DataTable.defaultProps.dataTableTools.pager, dataTableTools.pager),
      columnsToggle: _extends({}, DataTable.defaultProps.dataTableTools.columnsToggle, dataTableTools.columnsToggle)
    };
  }, [dataTableTools, selectable]);

  var filterTypes = _react.default.useMemo(function () {
    return {
      boolean: function boolean(rows, id, filterValue) {
        return rows.filter(function (row) {
          var rowValue = row.values[id];

          if (rowValue === undefined) {
            return true;
          }

          return filterValue !== rowValue;
        });
      }
    };
  }, []); // Use the state and functions returned from useTable to build our UI


  var instance = (0, _reactTable.useTable)({
    columns: columns,
    data: data,
    initialState: _extends({
      pageIndex: typeof backEndManagment.fetchData === 'function' ? 0 : pIndex
    }, initialState, {
      pageSize: pSize,
      sortBy: sorting,
      columnOrder: colOrder,
      hiddenColumns: hiddenCols,
      globalFilter: searchTerm,
      // Tell the usePagination hook that we'll handle our own data fetching
      // This means we'll also have to provide our own pageCount.
      pageCount: controlledPageCount,
      manualFilters: typeof backEndManagment.fetchData === 'function',
      manualPagination: typeof backEndManagment.fetchData === 'function',
      manualSortBy: typeof backEndManagment.fetchData === 'function'
    }),
    defaultColumn: {
      defaultCanSort: false,
      disableFilters: true
    },
    filterTypes: filterTypes,
    debug: true
  }, _reactTable.useFilters, _reactTable.useGlobalFilter, _reactTable.useSortBy, _reactTable.useExpanded, _reactTable.usePagination, _reactTable.useColumnOrder, _useUKFlexLayout.default, _reactTable.useRowSelect, function (hooks) {
    selectable && hooks.visibleColumns.push(function (columns) {
      return [// Column for selection
      {
        id: 'selection',
        width: 48,
        disableGlobalFilter: true,
        // The header can use the table's getToggleAllRowsSelectedProps method
        // to render a checkbox
        Header: function Header(_ref3) {
          var getToggleAllPageRowsSelectedProps = _ref3.getToggleAllPageRowsSelectedProps;
          return /*#__PURE__*/_react.default.createElement(_DataTable.IndeterminateCheckbox, getToggleAllPageRowsSelectedProps());
        },
        headerClassName: 'align-center',
        // The cell can use the individual row's getToggleRowSelectedProps method
        // to the render a checkbox
        Cell: function Cell(_ref4) {
          var row = _ref4.row;
          return /*#__PURE__*/_react.default.createElement(_DataTable.IndeterminateCheckbox, _extends({}, row.getToggleRowSelectedProps(), {
            title: ''
          }));
        }
      }].concat(columns);
    });
  });
  var getTableProps = instance.getTableProps,
      getTableBodyProps = instance.getTableBodyProps,
      headerGroups = instance.headerGroups,
      prepareRow = instance.prepareRow,
      page = instance.page,
      pageCount = instance.pageCount,
      rows = instance.rows,
      initialRows = instance.initialRows,
      visibleColumns = instance.visibleColumns,
      _instance$state = instance.state,
      sortBy = _instance$state.sortBy,
      pageSize = _instance$state.pageSize,
      columnOrder = _instance$state.columnOrder,
      hiddenColumns = _instance$state.hiddenColumns,
      filters = instance.initialState.filters,
      selectedFlatRows = instance.selectedFlatRows;
  var dataRows = typeof backEndManagment.fetchData === 'function' ? initialRows : page; // Built an Object to pass to each DataTableTool

  var dataTableToolsParams = _extends({}, instance, {
    tools: tools,
    context: {
      state: crudState,
      dispatch: crudDispatch
    },
    hasBackEndManagment: typeof backEndManagment.fetchData === 'function',
    pageCount: typeof backEndManagment.fetchData === 'function' ? Number(controlledPageCount) : pageCount,
    entriesCount: Number(controlledEntriesCount),
    setBackEndFilter: setBackEndFilter,
    pIndex: pIndex,
    setPIndex: setPIndex,
    searchTerm: searchTerm,
    setSearchTerm: setSearchTerm,
    loading: loading
  });

  var dragTimer;

  var handleGrab = function handleGrab(e) {
    var enableDrag = function enableDrag() {
      setIsDown(true);
      dataTableRef.current.classList.add('active');
      setStartX(e.pageX - dataTableRef.current.offsetLeft);
      setScrollLeft(dataTableRef.current.scrollLeft);
    };

    e.persist();

    if ((e.target.nodeName === 'TD' || e.target.nodeName === 'TH') && dataTableRef.current.scrollWidth > dataTableRef.current.parentElement.scrollWidth) {
      dragTimer = window.setTimeout(enableDrag, 500);
    }
  };

  var handleRelease = function handleRelease() {
    window.clearTimeout(dragTimer);
    setIsDown(false);
    dataTableRef.current.classList.remove('active');
  };

  var handleMove = function handleMove(e) {
    if (!isDown) return;
    e.preventDefault();
    var x = e.pageX - dataTableRef.current.offsetLeft;
    var walk = (x - startX) * 3; //scroll-fast

    dataTableRef.current.scrollLeft = scrollLeft - walk;
  };

  _react.default.useEffect(function () {
    return setSorting(sortBy);
  }, [setSorting, sortBy]);

  _react.default.useEffect(function () {
    return setPSize(pageSize);
  }, [setPSize, pageSize]);

  _react.default.useEffect(function () {
    return setColOrder(columnOrder);
  }, [setColOrder, columnOrder]);

  _react.default.useEffect(function () {
    return setHiddenCols(hiddenColumns);
  }, [setHiddenCols, hiddenColumns]); // Listen for changes in pagination and/or sorting and use the state to fetch the new data


  _react.default.useEffect(function () {
    return setPIndex(0);
  }, [pageSize, sortBy, searchTerm]);

  _react.default.useEffect(function () {
    if (fetchData) fetchData({
      pageIndex: pIndex,
      pageSize: pageSize,
      request: searchTerm || '',
      sortBy: sortBy
    });
  }, [fetchData, pageSize, sortBy, searchTerm, pIndex]);

  var sortRow = function sortRow(page) {
    if (sortBy && sortBy[0] && sortBy[0].desc && typeof backEndManagment.fetchData === 'function') {
      page.sort(function (a, b) {
        return a.index > b.index && 1 || -1;
      });
    }

    return page;
  }; // Render the UI for the table


  return /*#__PURE__*/_react.default.createElement(_react.default.StrictMode, null, /*#__PURE__*/_react.default.createElement("section", {
    className: (0, _clsx.default)('uk-data-table', className)
  }, children, dataTableTools && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-data-table__tools uk-data-table__tools--top"
  }, /*#__PURE__*/_react.default.createElement(_DataTable.DataTableTools, {
    position: "top-left",
    instance: dataTableToolsParams
  }), /*#__PURE__*/_react.default.createElement(_DataTable.DataTableTools, {
    position: "top-center",
    instance: dataTableToolsParams
  }), /*#__PURE__*/_react.default.createElement(_DataTable.DataTableTools, {
    position: "top-right",
    instance: dataTableToolsParams
  }, dataTableTools.custom, selectable && /*#__PURE__*/_react.default.createElement(_.Dropdown, {
    className: "uk-data-table__bulk-actions " + (selectedFlatRows.length > 0 ? '' : 'disabled'),
    align: "right",
    trigger: /*#__PURE__*/_react.default.createElement("span", null, "Actions"),
    disabled: selectedFlatRows.length < 1
  }, selectable(selectedFlatRows.map(function (d) {
    return d.original;
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-data-table__table",
    ref: dataTableRef
  }, /*#__PURE__*/_react.default.createElement("table", _extends({}, getTableProps(), {
    onMouseDown: handleGrab,
    onMouseUp: handleRelease,
    onMouseLeave: handleRelease,
    onMouseMove: handleMove,
    className: (0, _clsx.default)('uk-table', stripped && 'stripped', hoverable && 'hoverable', bordered && 'bordered')
  }), /*#__PURE__*/_react.default.createElement("thead", null, headerGroups.map(function (headerGroup, tr) {
    return /*#__PURE__*/_react.default.createElement("tr", _extends({}, headerGroup.getHeaderGroupProps(), {
      key: dataTableId + "-thead-tr-" + tr
    }), headerGroup.headers.map(function (column, th) {
      return /*#__PURE__*/_react.default.createElement("th", _extends({}, column.getHeaderProps(column.getSortByToggleProps()), {
        key: dataTableId + "-thead-th-" + th,
        title: undefined,
        className: (0, _clsx.default)(column.headerClassName, dataRows.length > 1 && column.canSort && 'is-sortable', dataRows.length > 1 && column.canSort && column.isSorted && column.isSortedDesc && 'has-sort--desc', dataRows.length > 1 && column.canSort && column.isSorted && !column.isSortedDesc && 'has-sort--asc')
      }), dataRows.length > 1 && column.canSort && /*#__PURE__*/_react.default.createElement("div", {
        className: "uk-svg"
      }, column.isSorted ? column.isSortedDesc ? /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 320 512"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
      })) : /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 320 512"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
      })) : /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 320 512"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
      }))), column.render('Header'));
    }));
  })), /*#__PURE__*/_react.default.createElement("tbody", _extends({}, getTableBodyProps(), {
    className: loading ? 'is-loading' : null
  }), loading ? /*#__PURE__*/_react.default.createElement("tr", {
    className: "is-loading"
  }, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: visibleColumns.length
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "loading"
  }))) : null, dataRows.length ? sortRow(dataRows).map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: dataTableId + "-tbody-tr-" + i
    }, /*#__PURE__*/_react.default.createElement("tr", _extends({}, row.getRowProps(getRowProps(row)), {
      className: (0, _clsx.default)('uk-data-table__tr', selectable && row.isSelected && 'is-selected', row.isExpanded && 'is-expanded', filters && filters.length && row.original[tools.filterToggle.key] === filters[0].value && 'is-archived'),
      key: "row_" + i
    }), row.cells.map(function (cell, td) {
      return /*#__PURE__*/_react.default.createElement("td", _extends({}, cell.getCellProps([{
        className: cell.column.className
      }, getColumnProps(cell.column), getCellProps(cell)]), {
        key: dataTableId + "-tbody-td-" + td
      }), /*#__PURE__*/_react.default.isValidElement(cell.value) ? cell.render('Cell') : /*#__PURE__*/_react.default.createElement("div", null, cell.render('Cell')));
    })), row.isExpanded ? /*#__PURE__*/_react.default.createElement("tr", _extends({}, row.getRowProps(), {
      className: (0, _clsx.default)('uk-data-table__tr', 'is-expanded', 'uk-data-table__tr--subRow', row.values.archived && 'is-archived'),
      key: "row_expanded_" + i
    }), /*#__PURE__*/_react.default.createElement("td", {
      colSpan: visibleColumns.length,
      style: {
        minWidth: instance.totalColumnsWidth,
        flexGrow: 1
      }
    }, renderRowSubComponent({
      row: row
    }))) : null);
  }) : /*#__PURE__*/_react.default.createElement("tr", null)))), dataTableTools && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-data-table__tools uk-data-table__tools--bottom"
  }, /*#__PURE__*/_react.default.createElement(_DataTable.DataTableTools, {
    position: "bottom-left",
    instance: dataTableToolsParams
  }), /*#__PURE__*/_react.default.createElement(_DataTable.DataTableTools, {
    position: "bottom-center",
    instance: dataTableToolsParams
  }), /*#__PURE__*/_react.default.createElement(_DataTable.DataTableTools, {
    position: "bottom-right",
    instance: dataTableToolsParams
  }))));
};

DataTable.propTypes = {
  /**
   * ID of the Switch (used to bind the label to the Switch)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,

  /**
   * ID of the Switch (used to bind the label to the Switch)
   * NB: the ID will be randomly generated if not set.
   */
  columns: _propTypes.default.any,

  /**
   * ID of the Switch (used to bind the label to the Switch)
   * NB: the ID will be randomly generated if not set.
   */
  data: _propTypes.default.any,

  /**
   * ID of the Switch (used to bind the label to the Switch)
   * NB: the ID will be randomly generated if not set.
   */
  context: _propTypes.default.any,

  /**
   * ID of the Switch (used to bind the label to the Switch)
   * NB: the ID will be randomly generated if not set.
   */
  initialState: _propTypes.default.any,

  /**
   * ID of the Switch (used to bind the label to the Switch)
   * NB: the ID will be randomly generated if not set.
   */
  dataTableTools: _propTypes.default.any,

  /**
   * ID of the Switch (used to bind the label to the Switch)
   * NB: the ID will be randomly generated if not set.
   */
  stripped: _propTypes.default.bool,

  /**
   * ID of the Switch (used to bind the label to the Switch)
   * NB: the ID will be randomly generated if not set.
   */
  hoverable: _propTypes.default.bool,

  /**
   * ID of the Switch (used to bind the label to the Switch)
   * NB: the ID will be randomly generated if not set.
   */
  bordered: _propTypes.default.bool,

  /**
   * ID of the Switch (used to bind the label to the Switch)
   * NB: the ID will be randomly generated if not set.
   */
  subComponent: _propTypes.default.any
};
DataTable.defaultProps = {
  initialState: {},
  stripped: false,
  hoverable: false,
  bordered: false,
  selectable: false,
  dataTableTools: {
    filterInput: {
      position: 'top-left',
      placeholder: 'Filter by ...',
      entry: 'entry',
      entries: 'entries'
    },
    filterToggle: {
      position: 'top-center',
      key: 'archived',
      label: 'Show archived entries'
    },
    pages: {
      position: 'top-right',
      label: ''
    },
    pagination: {
      position: 'bottom-left'
    },
    pager: {
      position: 'bottom-right'
    },
    custom: null
  },
  backEndManagment: {
    fetchData: null,
    loading: false,
    // pageIndex: 0,
    pageCount: 0,
    entriesCount: 0
  }
};
var _default = DataTable;
exports.default = _default;